import { useTranslation } from 'react-i18next';
import { useMatch } from 'react-router';

import { useUpdateAppSettings, useUser } from '~/api/user';
import { Breadcrumb, ColorPicker, Icon, Separator } from '~/components';
import { useBreadcrumbs } from '~/hooks/useBreadcrumbs';
import { useMediaQuery } from '~/hooks/useMediaQuery';
import { useColorThemeContext } from '~/providers/ColorThemeProvider/ColorThemeProvider.context';
import { routes } from '~/providers/RouterProvider/router.routes';
import { breakpoints } from '~/styles/media.css';

import { InviteeDiscountCountdown } from './InviteeDiscountCountdown';
import { homeBreadcrumbStyle, separatorStyle, topBarContainerStyle, topBarStyle, topBarWrapperStyle } from './TopBar.css';
import { TopBarMenu } from './TopBarMenu';

export const TopBar = () => {
  const { data: user } = useUser();
  const mutation = useUpdateAppSettings();

  const isMediumViewport = useMediaQuery(breakpoints.medium);
  const { colorTheme } = useColorThemeContext();
  const { t } = useTranslation(['common']);

  const isHome = useMatch(routes.dashboard);
  const breadcrumbs = useBreadcrumbs();

  return (
    <div className={topBarWrapperStyle}>
      <div className={topBarStyle}>
        <Breadcrumb.Root>
          {isHome ? (
            <Breadcrumb.Item aria-label={t('common:breadcrumbs.home')} className={homeBreadcrumbStyle}>
              <Icon name="Home" />
            </Breadcrumb.Item>
          ) : (
            <Breadcrumb.Link aria-label={t('common:breadcrumbs.home')} className={homeBreadcrumbStyle} to={routes.dashboard}>
              <Icon name="Home" />
            </Breadcrumb.Link>
          )}

          {breadcrumbs.map((breadcrumb, index) => {
            const isLast = index === breadcrumbs.length - 1;
            const is2ndLast = index === breadcrumbs.length - 2;
            const truncateItem = !is2ndLast && isMediumViewport;

            if (isLast || !breadcrumb.to) {
              return (
                <Breadcrumb.Item aria-current={isLast ? 'page' : undefined} key={breadcrumb.label} limitWidth={breadcrumb.isLiteral}>
                  {breadcrumb.label}
                </Breadcrumb.Item>
              );
            }

            return (
              <Breadcrumb.Link key={breadcrumb.label} limitWidth={breadcrumb.isLiteral} to={breadcrumb.to}>
                {truncateItem ? '…' : breadcrumb.label}
              </Breadcrumb.Link>
            );
          })}
        </Breadcrumb.Root>

        <div className={topBarContainerStyle}>
          {!isMediumViewport && <InviteeDiscountCountdown discount={user.inviteeDiscount} />}

          <ColorPicker
            onSelect={(colorTheme) => mutation.mutate({ appSettings: { theme: { ...user.appSettings.theme, appColor: colorTheme } } })}
            value={colorTheme}
          />

          <Separator aria-hidden className={separatorStyle} orientation="vertical" />

          <TopBarMenu />
        </div>
      </div>
    </div>
  );
};
